import React, { useState, useEffect } from 'react';

const AdminReviewsPanel = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending');

  const fetchReviews = async () => {
    try {
      const res = await fetch('/api/reviews/admin/all', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: localStorage.getItem('auth_token') })
      });
      const data = await res.json();
      if (Array.isArray(data)) setReviews(data);
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { fetchReviews(); }, []);

  const handleModerate = async (reviewId, action) => {
    try {
      const res = await fetch('/api/reviews/admin/moderate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          token: localStorage.getItem('auth_token'),
          reviewId,
          action 
        })
      });
      const data = await res.json();
      if (data.success) {
        setReviews(prev => prev.map(r => 
          r.id === reviewId ? { ...r, status: action === 'approve' ? 'approved' : 'rejected' } : r
        ));
      }
    } catch (e) {}
  };

  const filtered = reviews.filter(r => filter === 'all' || r.status === filter);
  const pendingCount = reviews.filter(r => r.status === 'pending').length;

  if (loading) return <div style={{ color: '#94a3b8', padding: '20px' }}>Loading reviews...</div>;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
        <h2 style={{ color: '#ffffff', fontSize: '20px', fontWeight: '700', margin: 0 }}>
          ⭐ Review Management {pendingCount > 0 && <span style={{
            background: '#ef4444',
            color: '#fff',
            fontSize: '12px',
            padding: '2px 8px',
            borderRadius: '10px',
            marginLeft: '8px',
            fontWeight: '700'
          }}>{pendingCount} pending</span>}
        </h2>
        <div style={{ display: 'flex', gap: '6px' }}>
          {['pending', 'approved', 'rejected', 'all'].map(f => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              style={{
                padding: '6px 14px',
                borderRadius: '8px',
                border: 'none',
                fontSize: '12px',
                fontWeight: '600',
                cursor: 'pointer',
                background: filter === f ? '#6366f1' : 'rgba(99,102,241,0.15)',
                color: filter === f ? '#ffffff' : '#a5b4fc',
                textTransform: 'capitalize'
              }}
            >
              {f} {f !== 'all' && `(${reviews.filter(r => r.status === f).length})`}
            </button>
          ))}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px 20px', 
          color: '#64748b',
          background: 'rgba(99,102,241,0.05)',
          borderRadius: '12px'
        }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>📭</div>
          <p>No {filter !== 'all' ? filter : ''} reviews yet</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {filtered.map(review => (
            <div key={review.id} style={{
              padding: '18px',
              background: review.status === 'pending' 
                ? 'rgba(251,191,36,0.08)' 
                : review.status === 'approved' 
                  ? 'rgba(16,185,129,0.08)' 
                  : 'rgba(239,68,68,0.08)',
              border: `1px solid ${
                review.status === 'pending' 
                  ? 'rgba(251,191,36,0.2)' 
                  : review.status === 'approved' 
                    ? 'rgba(16,185,129,0.2)' 
                    : 'rgba(239,68,68,0.2)'
              }`,
              borderRadius: '12px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
                <div>
                  <span style={{ color: '#ffffff', fontWeight: '700', fontSize: '15px' }}>{review.name}</span>
                  <span style={{ color: '#64748b', fontSize: '13px', marginLeft: '8px' }}>({review.email})</span>
                  <span style={{ 
                    color: '#94a3b8', 
                    fontSize: '12px', 
                    marginLeft: '8px',
                    background: 'rgba(99,102,241,0.15)',
                    padding: '2px 8px',
                    borderRadius: '6px'
                  }}>{review.role}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '14px' }}>{'⭐'.repeat(review.rating)}</span>
                  <span style={{
                    fontSize: '11px',
                    fontWeight: '700',
                    padding: '3px 10px',
                    borderRadius: '6px',
                    textTransform: 'uppercase',
                    background: review.status === 'pending' ? 'rgba(251,191,36,0.2)' : review.status === 'approved' ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)',
                    color: review.status === 'pending' ? '#fbbf24' : review.status === 'approved' ? '#34d399' : '#ef4444'
                  }}>{review.status}</span>
                </div>
              </div>
              
              <p style={{ 
                color: '#e2e8f0', 
                fontSize: '14px', 
                lineHeight: '1.6', 
                margin: '0 0 12px 0',
                fontStyle: 'italic'
              }}>
                "{review.text}"
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <span style={{ color: '#64748b', fontSize: '12px' }}>
                  {new Date(review.submittedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </span>
                
                {review.status === 'pending' && (
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => handleModerate(review.id, 'approve')}
                      style={{
                        padding: '8px 20px',
                        background: '#10b981',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '700',
                        cursor: 'pointer'
                      }}
                    >
                      ✅ Approve
                    </button>
                    <button
                      onClick={() => handleModerate(review.id, 'reject')}
                      style={{
                        padding: '8px 20px',
                        background: '#ef4444',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '700',
                        cursor: 'pointer'
                      }}
                    >
                      ❌ Reject
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminReviewsPanel;
